import React from "react";

import {
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet,
} from "@react-pdf/renderer";

import schoolLogo from "./savationChristLogo.png";
import defaultProfile from "./profileavartar.jpg";


const styles = StyleSheet.create({

    page: {
        size: "A4",
        padding: 28,
        backgroundColor: "#ffffff",
        fontFamily: "Helvetica",
    },

    header: {
        height: 90,
        backgroundColor: "#f1f1f1",
        borderBottomWidth: 4,
        borderBottomColor: "#f97316",
        padding: 12,
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 12,
    },

    logo: {
        width: 65,
        height: 65,
        objectFit: "contain",
    },

    headerInfo: {
        marginLeft: 15,
        flex: 1,
    },

    schoolName: {
        fontSize: 17,
        fontWeight: "bold",
        color: "#111111",
        marginBottom: 5,
    },

    headerText: {
        fontSize: 8,
        color: "#555555",
        marginBottom: 2,
    },

    titleBox: {
        width: 170,
        alignItems: "flex-end",
    },

    documentTitle: {
        fontSize: 11,
        fontWeight: "bold",
        color: "#f97316",
        textAlign: "right",
    },

    documentSubTitle: {
        fontSize: 8,
        color: "#555555",
        marginTop: 4,
        textAlign: "right",
    },

    mainRow: {
        flexDirection: "row",
        marginBottom: 10,
    },

    profileCard: {
        width: 210,
        backgroundColor: "#f8f8f8",
        borderLeftWidth: 5,
        borderLeftColor: "#c19a6b",
        padding: 12,
        flexDirection: "column",
        alignItems: "center",
    },

    profileImage: {
        width: 95,
        height: 95,
        borderRadius: 50,
        objectFit: "cover",
        marginBottom: 8,
    },

    teacherName: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#111111",
        textAlign: "center",
        marginBottom: 8,
    },

    profileInfo: {
        width: "100%",
    },

    infoRow: {
        flexDirection: "row",
        marginBottom: 5,
    },

    infoLabel: {
        width: 70,
        fontSize: 7.5,
        fontWeight: "bold",
        color: "#777777",
    },

    infoValue: {
        flex: 1,
        fontSize: 7.5,
        color: "#111111",
    },

    rightContent: {
        flex: 1,
        marginLeft: 12,
    },

    sectionHeader: {
        backgroundColor: "#111111",
        color: "#ffffff",
        fontSize: 9,
        fontWeight: "bold",
        padding: 6,
        marginBottom: 6,
        borderLeftWidth: 4,
        borderLeftColor: "#f97316",
    },

    card: {
        backgroundColor: "#ffffff",
        borderWidth: 1,
        borderColor: "#dddddd",
        padding: 10,
        marginBottom: 8,
    },

    assignmentRow: {
        flexDirection: "row",
        marginBottom: 5,
    },

    assignmentLabel: {
        width: 95,
        fontSize: 8,
        fontWeight: "bold",
        color: "#555555",
    },

    assignmentValue: {
        flex: 1,
        fontSize: 8,
        color: "#111111",
    },

    regulationSection: {
        marginTop: 2,
    },

    regulationGrid: {
        flexDirection: "row",
        gap: 10,
    },

    regulationColumn: {
        flex: 1,
    },

    regulationText: {
        fontSize: 7.5,
        color: "#333333",
        marginBottom: 4,
        lineHeight: 1.3,
    },

    authorization: {
        marginTop: 5,
        backgroundColor: "#f8f8f8",
        padding: 10,
        borderTopWidth: 2,
        borderTopColor: "#c19a6b",
    },

    signatureRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 20,
    },

    signatureBox: {
        width: "40%",
        borderTopWidth: 1,
        borderTopColor: "#111111",
        paddingTop: 5,
    },

    signatureText: {
        fontSize: 7,
        color: "#555555",
        textAlign: "center",
    },

    footer: {
        position: "absolute",
        bottom: 15,
        left: 28,
        right: 28,
        borderTopWidth: 1,
        borderTopColor: "#dddddd",
        paddingTop: 5,
        flexDirection: "row",
        justifyContent: "space-between",
    },

    footerText: {
        fontSize: 7,
        color: "#777777",
    },

});
const TeacherDataPDF = ({
    teacher,
    divisionName,
    subjectNames,
    gradeNames,
}) => {

    const profileImage = teacher?.profile_image_url || defaultProfile;

    return (

        <Document>

            <Page
                size="A4"
                orientation="landscape"
                style={styles.page}
            >

                <View style={styles.header}>

                    <Image
                        src={schoolLogo}
                        style={styles.logo}
                    />

                    <View style={styles.headerInfo}>

                        <Text style={styles.schoolName}>
                            {/* Jana L. Williams Educational Foundation */}
                            Salvation In Christ School System
                        </Text>

                        <Text style={styles.headerText}>
                            Zazay Community, Paynesville City, Monrovia
                            {/* Mt. Barclay, New Store Community, Monrovia Liberia */}
                        </Text>

                        <Text style={styles.headerText}>
                            {/* Contact: +231 777 272 609 */}
                            Website to SignIn on the School Potal: www.salvationinchristschoolsystem.com
                        </Text>

                    </View>


                    <View style={styles.titleBox}>

                        <Text style={styles.documentTitle}>
                            OFFICIAL TEACHER DATA SHEET
                        </Text>

                        <Text style={styles.documentSubTitle}>
                            Academic Staff Record
                        </Text>

                    </View>

                </View>


                <View style={styles.mainRow}>


                    <View style={styles.profileCard}>

                        <Image
                            src={profileImage}
                            style={styles.profileImage}
                        />


                        <Text style={styles.teacherName}>
                            {teacher.full_name}
                        </Text>


                        <View style={styles.profileInfo}>


                            <View style={styles.infoRow}>

                                <Text style={styles.infoLabel}>
                                    Qualification
                                </Text>

                                <Text style={styles.infoValue}>
                                    {teacher.qualification || "N/A"}
                                </Text>

                            </View>

                            <View style={styles.infoRow}>

                                <Text style={styles.infoLabel}>
                                    Email
                                </Text>

                                <Text style={styles.infoValue}>
                                    {teacher.email || "N/A"}
                                </Text>

                            </View>

                             <View style={styles.infoRow}>

                                <Text style={styles.infoLabel}>
                                    Secure Password
                                </Text>

                                <Text style={styles.infoValue}>
                                    {teacher.initial_password || "N/A"}
                                </Text>

                            </View>


                            <View style={styles.infoRow}>

                                <Text style={styles.infoLabel}>
                                    Contact
                                </Text>

                                <Text style={styles.infoValue}>
                                    {teacher.contact || "N/A"}
                                </Text>

                            </View>


                            <View style={styles.infoRow}>

                                <Text style={styles.infoLabel}>
                                    Salary
                                </Text>

                                <Text style={styles.infoValue}>
                                    {teacher.salary || "N/A"}
                                </Text>

                            </View>


                            <View style={styles.infoRow}>

                                <Text style={styles.infoLabel}>
                                    Added
                                </Text>

                                <Text style={styles.infoValue}>
                                    {teacher.date_add || "N/A"}
                                </Text>

                            </View>


                        </View>


                    </View>



                    <View style={styles.rightContent}>


                        <Text style={styles.sectionHeader}>
                            TEACHING ASSIGNMENTS
                        </Text>


                        <View style={styles.card}>


                            <View style={styles.assignmentRow}>

                                <Text style={styles.assignmentLabel}>
                                    Division
                                </Text>

                                <Text style={styles.assignmentValue}>
                                    {divisionName || "N/A"}
                                </Text>

                            </View>



                            <View style={styles.assignmentRow}>

                                <Text style={styles.assignmentLabel}>
                                    Subjects
                                </Text>

                                <Text style={styles.assignmentValue}>
                                    {subjectNames || "No subjects assigned"}
                                </Text>

                            </View>



                            <View style={styles.assignmentRow}>

                                <Text style={styles.assignmentLabel}>
                                    Grade Classes
                                </Text>

                                <Text style={styles.assignmentValue}>
                                    {gradeNames || "No grade classes assigned"}
                                </Text>

                            </View>



                            <View style={styles.assignmentRow}>

                                <Text style={styles.assignmentLabel}>
                                    Dependent Student
                                </Text>

                                <Text style={styles.assignmentValue}>
                                    {teacher.dependent_student || "None"}
                                </Text>

                            </View>


                        </View>



                        <Text style={styles.sectionHeader}>
                            TEACHER RULES AND REGULATIONS
                        </Text>



                        <View style={styles.card}>


                            <View style={styles.regulationGrid}>


                                <View style={styles.regulationColumn}>


                                    <Text style={styles.regulationText}>
                                        1. Be punctual and attend school regularly.
                                    </Text>


                                    <Text style={styles.regulationText}>
                                        2. Prepare and deliver effective lessons.
                                    </Text>


                                    <Text style={styles.regulationText}>
                                        3. Respect students, parents, and colleagues.
                                    </Text>


                                    <Text style={styles.regulationText}>
                                        4. Maintain professional boundaries.
                                    </Text>


                                    <Text style={styles.regulationText}>
                                        5. Protect school property and resources.
                                    </Text>


                                </View>


                                <View style={styles.regulationColumn}>


                                    <Text style={styles.regulationText}>
                                        6. Perform duties with commitment and integrity.
                                    </Text>


                                    <Text style={styles.regulationText}>
                                        7. Be a positive role model.
                                    </Text>


                                    <Text style={styles.regulationText}>
                                        8. Maintain a clean learning environment.
                                    </Text>


                                    <Text style={styles.regulationText}>
                                        9. Maintain professional appearance.
                                    </Text>


                                    <Text style={styles.regulationText}>
                                        10. Follow school policies and communication.
                                    </Text>


                                </View>


                            </View>


                        </View>



                    </View>


                </View>



                <View style={styles.authorization}>


                    <Text style={styles.sectionHeader}>
                        AUTHORIZATION
                    </Text>


                    <View style={styles.signatureRow}>


                        <View style={styles.signatureBox}>

                            <Text style={styles.signatureText}>
                                Teacher Signature
                            </Text>

                        </View>


                        <View style={styles.signatureBox}>

                            <Text style={styles.signatureText}>
                                Authorized Administrator
                            </Text>

                        </View>


                    </View>


                </View>



                <View style={styles.footer}>


                    <Text style={styles.footerText}>
                        {/* Jana L. Williams Educational Foundation */}
                        Salvation In Christ School System - SICSS
                    </Text>


                    <Text style={styles.footerText}>
                        Official Teacher Record -  Polu Integrated School Management System
                    </Text>


                </View>


            </Page>


        </Document>

    );

};


export default TeacherDataPDF;